import React from "react";
import { DynamicTab, NewDynamicTab } from "../../../components/Page";
import { RuvnlTitle } from "../components";
import { RajasthanDiscomAnalysis } from "./Discom_Analysis";
import { RajasthanDrawal } from "./Drawal";
import { RajasthanDiscomForecast } from "./Forecast";
import { RajasthanTrend } from "./TrendAnalysis";
import { RajasthanDrawalForecast } from "./Drawal_forecast";
import { TabSwitcher } from "../Raj_Dashboard";
import { RajasthanDiscomForecast2 } from "./Forecast2";
import { RajasthanDrawalTrend } from "./Drawal_Trend";
import { Rajasthan_Forecast_Surplus } from "./Forecast_Surplus";
import { RajasthanDrawalTrendUpload } from "./Drawal_Trend_upload";
import { RuvitalDemand } from "../../../config/DefaultDates";

export function RajDemand() {
  return (
    <>
      <NewDynamicTab
        defaultDates={RuvitalDemand}
        header="Demand"
        trendTabs={["Trend Analysis", "Restricted Demand Trend Analysis"]}
        middleComponent={<RuvnlTitle />}
        headerPrefixComponent={<TabSwitcher />}
        tabs={{
          "Discom Load ": <RajasthanDiscomAnalysis />,
          "Trend Analysis": <RajasthanTrend />,
          // "Forecast Upload": <RajasthanDrawalTrendUpload />,
          "Restricted Demand": <RajasthanDrawal />,
          "Restricted Demand Trend Analysis": <RajasthanDrawalTrend />,
          "Surplus/Deficit Analysis": <Rajasthan_Forecast_Surplus />,
        }}
        // disabledTabs={["Forecast Discom Load"]}
      />
    </>
  );
}
